import React,{useState,useEffect} from 'react'
import axios from 'axios'
import { Link as RouterLink, useNavigate, Navigate, resolveRoute} from 'react-router-dom'
import { useLocation } from 'react-router'
import { IoMdClose } from 'react-icons/io'
import {
  PaymentElement,
  Elements,
  CardElement,
  useStripe,
  useElements
} from '@stripe/react-stripe-js'
import {loadStripe} from '@stripe/stripe-js'
import {useAuth} from '../index'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
const FRONT_END_URL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_URL}` : `${process.env.REACT_APP_URL_TEST}`

export function PaymentPage({ customerSecretKey2 }) {
  const {auth2FA2, user2, logout, shoppingCart1, shoppingCart2} = useAuth()
  const [userInfo, setUserInfo] = useState(null)
  const cartItems = JSON.parse(window.localStorage.getItem('shopping-cart'))
  const [msg, setMsg] = useState('')
  useEffect(() => {
      if(userInfo==null){
        const handleSubmit = async (e) => {
          const { data: res } = await axios.post(`${APIURL}/account-info`, {token:window.localStorage.getItem('token')})
          if(res.msg==='user info ok'){
            setUserInfo(res.user)
          }
          else{
            setMsg(res.msg)
            setTimeout(() => {
              localStorage.removeItem('user')
              localStorage.removeItem('token')
              logout()
            }, 2000)
          }
        }
        setTimeout(handleSubmit, 1)
      }
  })
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
  const CARD_OPTIONS = {
    iconStyle: "solid",
    style: {
    base: {
      iconColor: "#c4f0ff",
      color: 'white',
      fontWeight: 500,
      fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: "24px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": { color: "#fce883" },
      "::placeholder": { color: "#87bbfd" }
    },
    invalid: {
      iconColor:'red',
      color: 'red'
    }
    }
  }
  const TotalPrice=()=>{
    let total=0
    cartItems.map((x)=>total += x.price * x.unit)
    total*=1.0825
    return (total.toFixed(2))*100
  }
  const amount = TotalPrice()
  const Payment = ({amount})=>{
    const [clientSecret, setClientSecret]=useState('')
    const [customerId,setCustomerId]=useState('')
    const [loading, setLoading]=useState(false)
    const stripe =useStripe()
    const element=useElements()
    const receiptId=`${Math.floor(Math.random() * 1000000)}`
    const navigate=useNavigate()
    useEffect(()=>{
      if(userInfo!=null){
        onClick2SecretKey()
      }
    },[amount])
    const onClick2SecretKey = async()=>{
        const {data:res1}=await axios.post(`${APIURL}/pre-onetime-payment`,{email:userInfo.email,'name':`${userInfo.firstname} ${userInfo.lastname}`,amount:amount})
        setClientSecret(res1.client_secret)
        setCustomerId(res1.customer_id)
    }
    const onClick2Pay=async(e)=>{
        e.preventDefault()
        setLoading(true)
        // if(!stripe||!element){return}
        const {err,paymentIntent}=await stripe.confirmCardPayment(clientSecret,{
          payment_method: {
            card: element.getElement(CardElement),
            billing_details:{email:userInfo.email,name:`${userInfo.firstname} ${userInfo.lastname}`}
          }
        })
        console.log(paymentIntent)
        if(paymentIntent.status=='succeeded'){
          const res2=await axios.post(`${APIURL}/onetime-payment`,{
            amount:amount,
            token:window.localStorage.getItem('token'),
            cart_items:JSON.parse(window.localStorage.getItem('shopping-cart')),
            id:paymentIntent.payment_method,
            customer_id:customerId,
            client_secret:clientSecret,
            receipt_id:receiptId,
            name:`${userInfo.firstname} ${userInfo.lastname}`,
            email:userInfo.email,
          })
          if(res2.data.success){
            localStorage.removeItem('shopping-cart')
            localStorage.setItem('user', JSON.stringify(res2.user))
            // localStorage.setItem('shopping_cart', [])
            shoppingCart1([])
            navigate(`/myaccount/payment-success?order=${clientSecret}&paid=${amount}&receipt_id=${receiptId}`)
          }
        }
        setLoading(false)
        // const {err} = await stripe.confirmPayment({
        //     elements,
        //     clientSecret,
        //     confirmParams:{
        //         return_url:`${window.location.origin}/myaccount/payment-success?amount=${amount}`
        //     },
        //     redirect: 'if_required',
        // })
    }
    if(!clientSecret||!stripe||!element){
        return (
            <div className='w-[100%] h-[100px] text-center'>
               <p className='flex text-xs pt-8 m-auto w-[160px]'>Please wait for a moment<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>
            </div>
        )
    }
    return (
      <div className='text-left m-auto md:mt-8 w-full sm:w-[580px] text-[8px]'>
      <h2 className='text-lg structure__main__subttl'>Payment Page</h2>
      {userInfo==null?<div className='w-max m-auto mt-8 mb-8'><div className='secondary-loader'></div></div>:<><div className='mb-4 w-full sm:w-[580px]'>
      <h3 className='mt-[1.2em] mb-1 leading-[1.75em] text-[12px] sm:text-[24px] font-bold bitter'>1. Order Summary</h3>
      {cartItems.filter((x) =>x.product_name=='sticker').length==1?<><div className='flex border-b text-xs mt-2'>
      <div className='w-[46px]'></div><div className='w-[274px]'>Items</div><div className='w-auto'>Send to</div>
      </div>{cartItems.map((x)=>(
      <>{x.product_name==='sticker'?
      <div className='w-full flex mb-2 text-xs'>
      <div className='flex w-40 mt-auto mb-auto'><img className='w-[42px] mr-1' src={x.img}/><div className='mt-auto mb-auto'>{x.product_name}</div></div><div className='flex w-40 mt-auto mb-auto'>${x.price}<IoMdClose className='mt-[5px] text-[9px]'/>{x.unit} US${x.price * x.unit}.00</div><div className='w-auto mt-auto mb-auto'>Delivery date: May 8, 2025<br/>{userInfo.zipcode} {userInfo.address1} {userInfo.address2} {userInfo.country}</div>
      </div>:''}</>
      ))}</>:''}
      {cartItems.filter((x) =>x.product_name!='sticker').length!=0?<><div className='flex border-b text-xs mt-2 mb-[6px]'>
      <div className='w-[46px]'></div><div className='w-[114px]'>Item Name</div><div className='w-[180px]'>Send to</div><div className='w-[104px]'>Unit</div>
      </div>{cartItems.map((x)=>(<>{x.product_name!='sticker'?
      <div className='w-full flex mb-2 text-xs'>
      <div className='flex w-40 mt-auto mb-auto'><img className='w-[42px] mr-1' src={x.img}/><div className='mt-auto mb-auto'>{x.product_name}</div></div><div className='mt-auto mb-auto w-[180px] text-[9px] leading-[12px]'>Delivery date: immediatery<br/>{userInfo.email}</div><div className='flex w-[100px] mt-auto mb-auto'>{x.price}<IoMdClose className='mt-[5px] text-[9px]'/>{x.unit}</div><div className='ml-auto w-auto mt-auto mb-auto'>{x.price * x.unit}.00</div>
      </div>:''}</>))}
      </>
      :''}
      <hr/>
      <div className='flex justify-between text-[12px]'>
      <div className='ml-[340px] mt-[6px] text-[9px] leading-[1.2]'>
      <div>Tax country: USA</div>
      <div>Sales tax 8.25%</div>
      </div>
      <div className='leading-[12px] mt-auto ml-auto'>{((cartItems.map((x1)=>x1.price*x1.unit)).reduce((x2,y2)=>x2+y2,0)*0.0825).toFixed(2)}</div>
      </div>
      <div className='text-right text-[14px]'>Total: US${((cartItems.map((x1)=>x1.price*x1.unit)).reduce((x2,y2)=>x2+y2,0)*1.0825).toFixed(2)}</div>
      </div>
      {/* <div className='mb-4'>
      <b>Delivering to {userInfo.firstname} {userInfo.lastname}</b><br/>
      <div className='mb-2'>{userInfo.email}</div>
      <div className='text-xs'>
      ✔ Download from site  ✔ Receive zip files via mail</div>
      set if order is sticker 
      <div className='text-xs'>Shipping to your address<br/>
      {userInfo.zipcode} {userInfo.address1} {userInfo.address2} {userInfo.country}<br/></div>
      <div className='w-[270px] leading-[.5]'><RouterLink className='structure__payment__link text-right text-[8px]' to='/myaccount'>+ Change User info</RouterLink></div>
      </div>
      <div className='mb-4'>
      <b>Offers</b><br/>
      None
      </div> */}

      <div className='mb-1 leading-[1.75em] text-[12px] sm:text-[24px] font-bold bitter'><b>2. Payment Infromation</b></div>
      <div onClick={onClick2Pay}>
      <fieldset className='FormGroup mb-[2px]'>
        <div className='w-[230px] FormRow border border-gray-800 text-[9px] pt-[2px] pb-[2px] pr-[2px] pl-[2px]'>
        <CardElement option={CARD_OPTIONS}/>
        </div>
      </fieldset>
      <div className='mt-[2em] sm:ml-auto w-fit'>
      <button disabled={!stripe||loading} className='bitter bg-[#414c75] hover:bg-[#365c88] w-[150px] h-[28px] text-white text-[12px]'>{loading?<div className='w-max m-auto'><div className='secondary-loader'></div></div>:'Complete Purchase'}</button>
      {loading?<div className='text-left text-[12px]'>It will take 4 or 5 seconds..</div>:''}
      </div>
      </div>

      </>}
      </div>
    )
  }
  return (
    <>
    <Elements 
      stripe={stripePromise}
      options={{
        mode:'payment',
        amount:amount,
        currency:'usd'
      }}
    >
      <Payment amount={amount} />
    </Elements>
    </>
  )
}
export const PaymentDonePage=() =>{
  const location=useLocation()
  const queryParams=new URLSearchParams(location.search)
  const amount=queryParams.get('paid')
  const clientSecret=queryParams.get('order')
  const receiptId=queryParams.get('receipt_id')
  const [sendReceipt, setSetReceipt] = useState(false)
  useEffect(()=>{
    if(!sendReceipt){
      onClick2SendReceipt()
      //1 reload shopping cart 
      //2 purchased item should be disable without logout
    }
  })  
  const onClick2SendReceipt = async(e)=>{
    try{
      if(clientSecret.length>10){
        setSetReceipt(true)
      }
    }catch(err){
      console.log('err',err)
    }
  }
  if(!sendReceipt){
    return (
      <div className='mt-[18px] w-[100%] h-[100px] text-center'>
      <p className='flex m-auto text-xs w-[160px]'>Please wait for a moment<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>
      </div>
    )
  }
  return (
    <div className='structure__payment__container'>
    <div className='mt-[2.4em] sm:mt-[4em] m-auto w-[360px]'>
    <h2  className='text-[#11489d] bitter mb-2'>Your purchase is successfully done.</h2>
    {clientSecret.length>10?<p className='text-xs'>Receipt#{receiptId}</p>:<p>System Error. Please contact to info@devcook.com</p>}
    <p class='text-xs'>You successfully paid US$
    {(amount/100).toFixed(2)}. <br/>We'll send receipt and purchased code zipfiles via mail shortly.</p>
    </div>
    </div>
  )
}